import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { FilterSettings } from '../project-filters/filter-settings';

@Component({
  selector: 'project-multi-selector',
  templateUrl: './project-multi-selector.html',
  styleUrl: './project-multi-selector.scss',
  standalone: false,
})
export class ProjectMultiSelectorComponent implements OnChanges {

  constructor(private readonly api: ApiService) { }

  @Input() public SelectedProjectId: number = 0;
  @Input() public selectionLimit: number = 25;
  @Output() public SelectedProjectIds = new EventEmitter<number[]>();

  public search: string = '';
  public isLoading: boolean = false;
  public projects: any[] = [];
  public filteredProjects: any[] = [];
  public selectedProjectIds: number[] = [];

  // Projects sharing this leading portion of the project number are pre-selected.
  private readonly projectNumberPrefixLength = 14;
  private readonly maxDisplayedProjects = 100;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['SelectedProjectId']) {
      this.loadProjects();
    }
  }

  get selectedProjectNumbers(): string {
    return this.selectedProjectIds
      .slice(0, 17)
      .map(projectId => this.projects.find(project => project.Id === projectId)?.ProjectNumber)
      .filter(projectNumber => !!projectNumber)
      .join(', ');
  }

  loadProjects() {
    this.search = '';
    this.projects = [];
    this.filteredProjects = [];
    this.selectedProjectIds = [];
    this.isLoading = true;

    this.api.MasterSchedule.GetMasterScheduleProjects(new FilterSettings()).subscribe((projects: any[]) => {
      const selectedProjectPrefix = this.getProjectNumberPrefix(
        projects.find(project => project.Id === this.SelectedProjectId)?.ProjectNumber);

      this.projects = projects.filter(project => project.Id !== this.SelectedProjectId);
      const prefixMatches = selectedProjectPrefix
        ? this.projects.filter(project => this.getProjectNumberPrefix(project.ProjectNumber) === selectedProjectPrefix)
        : [];
      this.projects = [...prefixMatches, ...this.projects.filter(project => !prefixMatches.includes(project))];
      this.selectedProjectIds = prefixMatches
        .slice(0, this.selectionLimit)
        .map(project => project.Id);

      this.applyProjectFilter();
      this.isLoading = false;
      this.SelectedProjectIds.emit(this.selectedProjectIds);
    });
  }

  applyProjectFilter() {
    const search = this.search.trim().toLowerCase();
    this.filteredProjects = this.projects
      .filter(project => {
        if (!search) {
          return true;
        }
        const projectNumber = `${project.ProjectNumber ?? ''}`.toLowerCase();
        const itemDescription = `${project.ItemDescription ?? ''}`.toLowerCase();
        return projectNumber.includes(search) || itemDescription.includes(search);
      })
      .slice(0, this.maxDisplayedProjects);
  }

  toggleProject(projectId: number) {
    if (this.selectedProjectIds.includes(projectId)) {
      this.selectedProjectIds = this.selectedProjectIds.filter(id => id !== projectId);
    } else if (this.selectedProjectIds.length < this.selectionLimit) {
      this.selectedProjectIds = [...this.selectedProjectIds, projectId];
    }

    this.SelectedProjectIds.emit(this.selectedProjectIds);
  }

  private getProjectNumberPrefix(projectNumber: string | null | undefined): string {
    return `${projectNumber ?? ''}`.slice(0, this.projectNumberPrefixLength);
  }

}
